// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Upm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/upm/1.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>项目背景</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>课程亮点</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>行程参考</div>
                                <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>报名须知</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/4.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/5.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/6.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/7.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/8.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/9.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/10.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/11.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/12.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/13.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/14.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/15.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/16.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/17.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/18.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/19.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/20.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/21.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/22.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/23.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/24.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/25.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/26.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/27.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/28.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/29.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/30.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/31.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/32.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 3 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/33.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/34.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/upm/35.jpg")} /></div>
                            </div>}
                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Upm);